import { Controller } from '@hotwired/stimulus';
import { SearchesMixin } from '../../../mixins/searches_mixin';

export default class extends Controller {
  static values = {
    scope: String,
    noResultsMessage: String,
  };

  initialize() {
    SearchesMixin(this)

    this.element.classList.add('live-search', 'live-search--with-margin');

    const params = {
      selector: this.element,
      query: { scope: this.scopeValue },
      noResultsMessage: this.noResultsMessage(),
    };

    this.initializeSearch(params, {});
  }

  noResultsMessage() {
    if (!this.hasNoResultsMessageValue) {
      return 'Nie znaleziono pasujących wyników';
    }

    return this.noResultsMessageValue;
  }
}
